module.exports = __webpack_public_path__ + "static/fonts/weathericons-regular-webfont.4618f0d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/weather-icons/font/weathericons-regular-webfont.ttf
// module id = GNql
// module chunks = 1